import { render } from "./HeroiconsOutlineDownload.vue?vue&type=template&id=00013c58"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDownload.vue"]])

export default __exports__